import { useGetPerformanceBonusQuery } from "../../../../../../../../../services/PerformanceHistory/performanceHistoryAPI";
import { PerfHistoryDataProps } from "../ABOProfilePerfHistoryKPIs";

const ABOProfilePerfHistoryPerformanceBonus = ({
  affAbo,
  locale,
  isoCountryCode,
  period,
  periodCount = 12,
  children,
}: PerfHistoryDataProps) => {
  const { isFetching, data, isError } = useGetPerformanceBonusQuery({
    affAbo,
    period,
    periodCount,
    locale,
    market: isoCountryCode,
  });

  return <>{children({ data, isFetching, isError })}</>;
};

export default ABOProfilePerfHistoryPerformanceBonus;
